import React, { Fragment } from 'react';
import { AppWrappperHOC } from '../../Root/HOC';
import StyledLanding from '../../../components/StyledLanding';
import Container from '../../../components/Container';
import endPoints from '../../../config/endPoints';
import { MERCHANTS } from '../constants';
// import Commons from '../Commons/index';

function Merchant() {
  const { BENIFIT_GIFT_CARD = [], MERCHANT_CARD = [], GIFT_CARD_NEED = [], HOW_IT_WORKS = [] } = MERCHANTS;
  return (
    <StyledLanding>
      <section className="banners sm-none" style={{ backgroundImage: `url(${endPoints.MERCHANT_REWARD_WALL})` }} >
        <Container>
          <div className="row">
            <div className="col-md-6 caption animated wow fadeIn">
              <h1>Discover, Engage and Retain <br /> Customers with Gift Cards</h1>
              <p className="mrg-2-t">Zaggle is here to help businesses with Merchant Gift Cards Program. From custom branding to managing card inventory, reloading the cards to running the campaigns, measuring the metrics to driving the revenue. We will do all that for you.</p>
            </div>
            <div className="col-md-6"></div>
          </div>
        </Container>
      </section>
      <img src={endPoints.PROPEL_WALL_MOBILE} alt="mobile wall" className="res-img mobile-banner lg-none" />
      <section className="padd-section default-section animated wow fadeIn">
        <Container>
          <div className="row">
            <div className="col-md-4">
              <h2 className="font-size-32 underline-left">Why Merchant<br /> Gift Cards?<hr /></h2>
            </div>
            <div className="col-md-8">
              <p>
                Implementing a customer gift card program is a proven way to increase business and generate more sales. Keeping customers happy and excited with your business increases customer lifespan and drives repeated sales.
                <br /><br />
                Gift cards drive new walk-ins into the store and help to build brand awareness. Additionally, customers spend more than the value of card, driving larger sales.
                <br /><br />
                Corporates look for innovative gifting for their rewards, recognition, and incentives programs for their employees and channel partners. A significant portion of the Corporate budget is now allocated to deploying Gift Card programs.
              </p>
            </div>
          </div>
        </Container>
      </section>
      <section id="how-it-works" className="padd-section text-center gray-bg pad-8-b animated wow fadeIn">
        <Container>
          <div className="section-title text-center">
            <h2 className="underline-center">Benefits of Gift Cards<hr /></h2>
          </div>
        </Container>
        <Container>
          <div className="row">
            {BENIFIT_GIFT_CARD.map((item) => (
              <div className="col-md-6 col-lg-4" key={item.keyIndex}>
                <div className="feature-block">
                  <div className="img-height">
                    <img src={item.image} alt={item.alt} className="icons" />
                  </div>
                  <div dangerouslySetInnerHTML={{ __html: item.htmlHeader }}></div>
                  <div dangerouslySetInnerHTML={{ __html: item.htmlData }}></div>
                </div>
              </div>
            ))}
          </div>
        </Container>
      </section>
      <section className="padd-section default-section merchant-section dot-bg-left-white animated wow fadeIn">
        <Container>
          <div className="row">
            <div className="col-md-6">
              <img src={endPoints.MERCHANT_CARD} alt="cards" className="res-img" />
            </div>
            <div className="col-md-6">
              {MERCHANT_CARD.map((item) => (
                <Fragment key={item.keyIndex}>
                  <div className="underline-left" dangerouslySetInnerHTML={{ __html: item.htmlHeader }}></div>
                  <div dangerouslySetInnerHTML={{ __html: item.htmlData }}></div>
                  <br />
                </Fragment>
              ))}
            </div>
          </div>
        </Container>
      </section>
      <section className="padd-section text-center default-section animated wow fadeIn">
        <Container>
          <div className="section-title text-center">
            <h2 className="underline-center">Everything we need for Gift Card<hr /></h2>
            <p>&nbsp;</p>
          </div>
        </Container>
        <Container>
          <div className="row">
            {GIFT_CARD_NEED.map((item) => (
              <div className="col-md-6 col-lg-4" key={item.keyIndex}>
                <div className="feature-block">
                  <div className="rounded-img">
                    <img src={item.image} alt={item.alt} className="icons" />
                  </div>
                  <div dangerouslySetInnerHTML={{ __html: item.htmlData }}></div>
                </div>
              </div>
            ))}
          </div>
        </Container>
      </section>
      <img src={endPoints.MERCHANT_HAND_SHARE} alt="merchant hand share" className="res-img animated wow fadeIn" />
      <section className="padd-section text-center default-section pad-8-b mrg-5-t animated wow fadeIn">
        <Container>
          <div className="section-title text-center">
            <h2 className="underline-center">How it Works <hr /></h2>
          </div>
        </Container>
        <Container>
          <div className="row">
            {HOW_IT_WORKS.map((item) => (
              <div key={item.keyIndex} className="col-md-6 col-lg-4">
                <div className="feature-block">
                  <div className="img-height">
                    <img src={item.image} alt={item.alt} className="icons" />
                  </div>
                  <div dangerouslySetInnerHTML={{ __html: item.htmlData }}></div>
                </div>
              </div>
            ))}
          </div>
        </Container>
      </section>
    </StyledLanding>
  );
}

const component = AppWrappperHOC(Merchant);

export { Merchant };
export default component;



// WEBPACK FOOTER //
// client/containers/StaticPages/Merchant/index.js